import React from "react";
import { Menu, Avatar } from "antd";
import { UserOutlined, LogoutOutlined } from "@ant-design/icons";
import { NavLink } from "react-router-dom";
import { useAuth } from "../../hooks/AuthProvider";
import { useUserStore } from "../../store/user";

const RightMenu = ({ mode }) => {
  const auth = useAuth();
  const { imageUrl } = useUserStore();

  const handleLogout = () => {
    auth.logOut();
  };

  return (
    <Menu mode={mode}>
      <Menu.SubMenu
        title={
          <>
            <Avatar size="large" src={imageUrl} />
          </>
        }
      >
        <Menu.Item key="about-us">
          <NavLink to="/profile">
            <UserOutlined /> Profile
          </NavLink>
        </Menu.Item>
        <Menu.Item key="log-out" onClick={handleLogout}>
          <LogoutOutlined /> Logout
        </Menu.Item>
      </Menu.SubMenu>
    </Menu>
  );
};

export default RightMenu;